export enum BannerTemplates {
  CASINO = "Casino",
  SLOTS = "Slots",
  IMG = "Simple image",
  ONE_ODD = "One Odd",
  TENNIS = "Tennis Match",
  TEAMS_NO_DRAW = "Two teams without draw",
  TEAMS_DRAW = "Two teams with draw",
  TEXT = "Just text",
  LIVECASINO = "LiveCasino",
  OMNICHANNEL = "Omnichannel",
}
export interface I_NewCarousel {
  typeOfTemplate: BannerTemplates;
  priority?: number;
  showLogged?: string;
  vipLevel?: string;
  bannerDesktopImage?: string;
  bannerMobileImage?: string;
  startDate?: string;
  endDate?: string;
  fromHour?: string;
  toHour?: string;
  superTitle?: string;
  buttonText?: string;
  simpleImageTemplateOrTextLink?: string;
  textLines?: string[];
  oddBet?: number;
  eventId?: number;
  matchKey?: number;
  leagueName?: number;
  sportTypeName?: string;
  whoVsWhow?: string;
  matchHour?: string;
  leftTeam?: string;
  leftTeamBetKey?: number;
  drawBetKey?: number;
  rightTeamName?: string;
  rightTeamBetKey?: number;
  leftShirtImage?: string;
  rightShirtImage?: string;
  oneOddAmount?: number;
  drawAmount?: number;
  leftTeamAmount?: number;
  rigthTeamAmount?: number;
  countdownStart?: string;
  countdownEnd?: string;
  countdownTitle?: string;
  countdownFormat?: string;
  countdownPositionMobile?: string;
  countdownPositionDesktop?: string;
}
